import * as z from "zod";

export const approveAndFileClaim = {
  name: "approveAndFileClaim" as const,
  input: z.object({ returnId: z.string() }),
  output: z.null(),
};
